import { type PropsWithChildren } from 'react';

import {
  type DataTestId,
  type StylingProps,
} from '@dynatrace/strato-components/core';

//#region Typings

/**
 * Accepted properties for the Select Suffix
 * @public
 */
export type SelectV2SuffixProps = PropsWithChildren<unknown> &
  StylingProps &
  DataTestId;
//#endregion

/**
 * The `SelectV2.Suffix` component allows you to specify any content, that should
 * be prefixed in the trigger element. The `SelectV2.Suffix` component is only valid
 * within the `SelectV2.Trigger` and `SelectV2.Option` element.
 * @example
 * ```tsx
 * <SelectV2.DisplayValue>
 *   <SelectV2.Suffix>
 *     <WhatsNewIcon />
 *   </SelectV2.Suffix>
 * </SelectV2.DisplayValue>
 * ```
 * @public
 */
export function SelectV2Suffix(props: SelectV2SuffixProps): null {
  return null;
}
